<template>
  <div class="ui-block">
    <div class="ui-block-content photo-container">
      <!-- W-Latest-Photo -->
      <div class="row">
        <h6 class="title col col-9">Most recent items</h6>
        <router-link :to="{ name: 'GroupsItems' }">
          <span class="col col-3 see-all">See All</span>
        </router-link>
      </div>

      <ul class="widget">
        <li class="mb-3" v-for="item in showSelectedItems" :key="item._id">
          <div class="widget-container">
            <router-link :to="`/s-app/item-details/${item.id}`">
            <div class="row align-items-center">
              <div class="col col-4">
                <img :src="getItemImagePath(item)" alt="Item"/>
              </div>
              <div class="col col-8 pl-0">
                <div class="row">
                  <span class="col col-12 title item-title">{{
                    item.title
                  }}</span>
                  <span class="col col-12 title item-description" v-html="item.description"></span>
                  <div class="col col-12 ">
                    <div class="free-content" v-if="isItemFree(item)">
                      <div class="title item-price">
                        <span>Free</span>
                      </div>
                    </div>
                    <div v-if="!paymentPointsAndCash(item)">
                      <div class="title item-price d-flex flex-wrap" v-if="item.points > 0">
                        {{ item.points }}
                        <img
                          class="mr-1 ml-1"
                          src="/img/Polygon_7.svg"
                          alt="Swampum"
                          width="12"
                          height="12"
                        />
                      </div>
                      <div class="title item-price d-flex flex-wrap" v-if="item.cash > 0">
                        {{ item.cash | toCurrency }}
                      </div>
                    </div>
                    <div class="title item-price d-flex flex-wrap" v-else>
                      {{ item.points }}
                      <img
                        class="mr-1 ml-1"
                        src="/img/Polygon_7.svg"
                        alt="Swampum"
                        width="12"
                        height="12"
                      />
                      <span class="ml-2 mr-2 title or-text">or</span>
                      <span class="mr-1" v-if="item.cash > 0">
                        {{ item.cash | toCurrency }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>          
      </li>
    </ul>
      
      <!-- .. end W-Latest-Photo -->
    <div
      v-if="$route.path.includes('group-page') && items.length > 9"
      class="text-right"
    ></div>
  </div>
  </div>
</template>

<script>
import ItemHelperVue from "../../mixins/ItemHelper.vue";
export default {
  name: "LastPhoto",
  props: ["items"],
  mixins: [ItemHelperVue],

  data() {
    return {
      appearItems: false,
      rangeDisplayedItems: 3,
    };
  },
  methods: {
    viewMoreItems(e) {
      this.rangeDisplayedItems += 9;
      e.preventDefault();
      this.appearItems = true;
    },
    paymentPointsAndCash(item) {
      return item.cash > 0 && item.points > 0;
    },
    isItemFree(item) {
      return item.cash === 0 && item.points === 0;
    },
  },
  computed: {
    lessThanNineItems() {
      if (this.items.length > 3) {
        return this.items.slice(0, 3);
      }
      return this.items;
    },
    showMoreItems() {
      if (this.items.length > this.rangeDisplayedItems) {
        return this.items.slice(0, this.rangeDisplayedItems);
      }
      return this.items;
    },
    showSelectedItems() {
      if (this.appearItems === true) {
        return this.showMoreItems;
      }
      return this.lessThanNineItems;
    },
  },
};
</script>

<style lang="scss" scoped>
.link-disabled {
  color: #8f9491;
}

.widget-container {
  border: 2px solid #3f3838;
  padding: 1px;
}

.see-all{
  margin-left: 14em;
  margin-bottom: 13em;
}

@media only screen and (max-width: 768px) {
  .photo-container {
    max-height: 200px;
    overflow: auto;
  }
}
.selected-items {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}
.title {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  display: flex;
  align-items: center;
  letter-spacing: 1.5px;
  color: $black;
  opacity: 0.7;
}
.item-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.15px;
  opacity: 0.87;
}
.item-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-word !important;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.25px;
  opacity: 0.6;
}
.item-price {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  opacity: 0.87;
}
.or-text {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.6;
}

</style>
